import React, { useContext, useRef, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';
import  PropTypes from 'prop-types';
import { Divider, Row, Col } from "antd";
import {
    SectionSpacing,
    GhostButtonComponent,
    PrimaryButtonComponent,
    SummaryLabel,
    SummaryData,
    DataHeading,
    DisplayFlex
} from '../../../../../../CommonComponents/commonStyles';
import Breadcrumb from "../../../../../../CommonComponents/Breadcrumb/Breadcrumb";
import { RecommendAnExchangesHeading, Heading, SectionHeading, HrDivider, NavigationButtonGroup, NavigationGroupButton, PrintDiv, PrintButton, ButtonLoader } from '../../styles';
import Context from '../../context';
import { NavigationBtnContainer, CustomSectionSpacing } from '../../styles';
import ExchangeOptions from '../exchangeOptions';
import ExchangeSchedule from '../exchangeSchedule';
import { FlexContainer, AddTransaction, AddExchangeSection, AddExchangeMessage } from '../exchangeReview/styles';
import {
    ScheduleType as ScheduleTypeConstants,
    ExchangesMaxLimit as ExchangesMaxLimitConstant
} from '../../constants';
import { calTotalAmount } from '../../util';
import EditButton from '../editButton';
import FromTable from '../exchangeReview/FromTable';
import ToTable from '../exchangeReview/ToTable';
import SpawnTable from '../confirmation/SpawnTable';
import {
    addAnotherExchangeForSchedule,
    cancelAllSpawnsForExchangeSchedule
} from '../../../../../../services/apiServices';
import { SubSection, ViewEditField, ViewLabel, CustomTableForPrint } from './styles'
import { AlertMessagePrimary } from '../popup/index';
//import ReactToPrint from 'react-to-print';
import PrintComponents from "react-print-components";
import loaderIcon from "../../../../../../assets/icons/loader.gif";
import printIcon from "../../../../../../assets/icons/print.svg";
import { getPrimaryAccount } from '../../../../../../utils/sessionUtil';
import { todayDate, initiateTracking, recordError,isAllShareAllPool } from '../../../../../../utils/commonUtil';
import Preloader from '../../../../../../CommonComponents/Preloader/Preloader';
import 'moment-timezone';
import { checkCSRBusinessFunction } from "../../../../../../CSR/utils/CommonUtils";
import { BUSINESS_FUNCTION } from '../../../../../../CSR/utils/csrBusinessFunctionMapper';
import BreadcrumbComponent from '../../../../../../CommonComponents/Breadcrumb/Breadcrumb';
import { AlertContent, Types } from '../../../../../../CommonComponents/ContentMessages';
import { GeneralButton, CapsuleButton } from '../../../../../../CommonComponents/Commons/commonComponents';

const breadcrumbRoutes = [
    {
        routeName: 'Home',
        path: '/',
    },
    {
        routeName: 'Investments',
        path: '/investments',
    },
    {
        routeName: 'Exchange Activity',
        path: '/investments/exchange-activity',
    },
    {
        routeName: 'View and Edit Exchange',
        path: '/investments/recommend-an-exchange/:id/view',
    },
];

export const CustomPrintTable = ({dataSource=[],columns=[]}) => {
    return (
        <CustomTableForPrint data-test="customTablePrint">
            <thead>
                <tr>
                {columns.map((data, i) => {
                    return (
                        data.title && <th key={i}>
                            <div>{typeof data.title == 'string' ? data.title : data.title()}</div>
                        </th>
                    )
                })}
                </tr>
            </thead>
            <tbody>
            {dataSource.map((data, i) => {
                return (
                    <tr key={i}>
                        {columns.map(val => {
                            return (
                                <td>{val.render(data)}</td>
                            )
                        })}
                    </tr>
                )
            })}
            </tbody>
        </CustomTableForPrint>
    )
}

export const CustomPrintSpawnTable = ({dataSource=[],columns=[]}) => {
    return (
        <CustomTableForPrint data-test = "customSpawnTable">
            <thead>
                <tr>
                {columns.map(data => {
                    return (
                        <th>
                            <div>{typeof data.title == 'string' ? data.title : data.title()}</div>
                        </th>
                    )
                })}
                </tr>
            </thead>
            <tbody>
            {dataSource.map(data => {
                return (
                    <tr>
                        {columns.map(val => {
                            return (
                                <td>{val.render ? val.render(data[val.key] , data): data[val.key]}</td>
                            )
                        })}
                    </tr>
                )
            })}
            </tbody>
        </CustomTableForPrint>
    )
}

const ViewAndEdit = (props) => {
    const { exchangeDetails = {}, history, userId, handleBack, edit, isLoading, handleExit, isNew, id, location, 
        refreshExchangeDetails, persistContext, isBalanceZero, spawnsLoading, setSpawnsLoading, csrBusinessFunction } = props;
    const { exchangeContext, setExchangeContext } = useContext(Context);
    const { from, to, spawns } = exchangeContext || {};
    const [spawnsArr, setSpawns] = useState(spawns)
    const [isExchangeHidden, setExchange] = useState(false)
    const [cancelAllExchangePopUp, handleCancelAllExchangePopUp] = useState(false);
    const [isAddAnotherExchange, setAddAnotherExchange] = useState(false);
    const [addExchangeFailed, setAddExchangeFailed] = useState(false);
    const componentRef = useRef();
    const isPrint = () => window.matchMedia('print');
    
    const isAllShareAllPoolExist=isAllShareAllPool();
    const updatedEdit = edit && !isBalanceZero && !isAllShareAllPoolExist;
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    useEffect(() => {
        if (spawns) {
            setSpawns(spawns)
        }
    }, [spawns]);

    const addPayment = () => {
        const txnId = exchangeDetails.exchScheduleId;
        setAddAnotherExchange(false);
        setSpawnsLoading(true);        
        addAnotherExchangeForSchedule({ userId, txnId }).then((res) => {
            initiateTracking('addExchange', "View and Edit Exchange", "Recommend exchange schedule", 'Add Another Exchange - Recurring Exchange');
            refreshExchangeDetails();                       
        }).catch(function (error) {
            setAddExchangeFailed(true);
            setSpawnsLoading(false);
        })
    };

    const cancelAllExchange = () => {
        const txnId = exchangeDetails.exchScheduleId;
        cancelAllSpawnsForExchangeSchedule({ userId, txnId }).then((res) => {
            handleCancelAllExchangePopUp(false);
            initiateTracking('button', "View and Edit Exchange", "", 'Cancel All Remaining Exchanges - Recurring Exchange');
            history.push('/investments/exchange-activity');
        })
    };

    const cancellingReversingSpawn = (type, exchPendingSpawnId) => {
        const cancelReverseSpawns = spawnsArr.map((spawn) => {
            if (spawn.exchPendingSpawnId === exchPendingSpawnId) {
                if (type === 'cancelSpawn')
                    spawn.cancelling = true;
                if (type === 'reverseSpawn')
                    spawn.reversing = true;
            }
            return spawn;
        });
        setSpawns(cancelReverseSpawns);
    }

    const hideCompeletedExchange = () => {
        try {
            const filterSpawn = spawnsArr.filter((obj, i) => obj.status !== 'Completed' && obj.status !== 'Exchange Completed');
            initiateTracking('button', "View and Edit Exchange", "", 'Hide Completed Exchanges - Recurring Exchange');
            setSpawns(filterSpawn);
            setExchange(true)
        } catch (error) {
          recordError(error);
        }
    }

    const showAllExchange = () => {
        try {
            initiateTracking('button', "View and Edit Exchange", "", 'Show All Exchanges - Recurring Exchange');
            setSpawns(spawns);
            setExchange(false)
        } catch (error) {
          recordError(error);
        }
    }

    // Check the feature is avalilable by the particular csr user
    const checkCsrBusiness = businessFunction => {
        return checkCSRBusinessFunction(BUSINESS_FUNCTION[businessFunction], csrBusinessFunction);
    }

    const getCurrentSpawn = () => {
        if(Object.keys(exchangeDetails).length>0 && !spawnsLoading){
            return spawnsArr.find((spawn) => exchangeDetails.displayInstrctnSpawnId === spawn.exchPendingSpawnId).exchangeId
        }
    }

    const printClicked = () => {
        try {
            const exchangeType = from && from.scheduleType === ScheduleTypeConstants.recurring ? 'Recurring Exchange' : 'One Time Exchange';
            const title = updatedEdit ? 'View and Edit Exchange' : 'View Exchange';
            initiateTracking('print', `${title}`, "", `Print - ${exchangeType}`);
            return componentRef.current;
        } catch (error) {
          recordError(error);
        }
    }

    const backClicked = () => {
        try {
            const exchangeType = from && from.scheduleType === ScheduleTypeConstants.recurring ? 'Recurring Exchange' : 'One Time Exchange';
            const title = updatedEdit ? 'View and Edit Exchange' : 'View Exchange';
            initiateTracking('back2', `${title}`, "", `Back - ${exchangeType}`);
            history.push({
                pathname: `/investments/exchange-activity`,
            });
        } catch (error) {
          recordError(error);
        }
    }

    if (isLoading) return <Preloader data-test="loader"/>
    return (
        <>
            <BreadcrumbComponent data-test="breadcrumb" breadcrumbRoutes={breadcrumbRoutes} />
            <div ref={componentRef} data-test="maincomponent">
                <RecommendAnExchangesHeading>
                    {from && from.scheduleType === ScheduleTypeConstants.recurring ?
                        `Schedule ID: ${id}` :
                        `Transaction ID: ${id}`
                    }
                </RecommendAnExchangesHeading>
                <SectionSpacing className="mb-30">
                    <Row>
                        <Col xs={12} md={24}>
                            <SummaryLabel>{exchangeDetails.fundName}</SummaryLabel>
                        </Col>
                        <Col xs={12} md={24}>
                            <SummaryData>{getPrimaryAccount()?.accountNumber}</SummaryData>
                        </Col>
                    </Row>
                </SectionSpacing>
                <SectionSpacing className="mt-30 mb-30">
                    <SubSection>
                        <FlexContainer wrapInMobile>
                            <div>
                                <ViewEditField>
                                    <DataHeading>Entered Date: </DataHeading>
                                    <Heading className="ml-10">{from && from.scheduleType === ScheduleTypeConstants.recurring ? moment(moment.tz(exchangeDetails.exchangeCreateDate, 'America/New_York')).format('MM/DD/YYYY') : moment(moment.tz(exchangeDetails.enteredDate, 'America/New_York')).format('MM/DD/YYYY')}</Heading>
                                </ViewEditField>
                                <ViewEditField>
                                    <DataHeading>Status:</DataHeading>
                                    <Heading className="ml-10">{exchangeDetails.status}</Heading>
                                </ViewEditField>

                            </div>
                            {from && from.scheduleType === ScheduleTypeConstants.onetime &&
                                <>
                                    <HrDivider hideInMobile />
                                    <div>
                                        <ViewEditField>
                                            <DataHeading>Recieved date & time: </DataHeading>
                                            <Heading className="ml-10">{moment(moment.tz(exchangeDetails.receivedDate, 'America/New_York')).format('MM/DD/YYYY [at] hh:mm A')}</Heading>
                                        </ViewEditField>
                                        <ViewEditField>
                                            <DataHeading>{exchangeDetails.status === 'Completed' ? 'Trade Date:' : 'Estimated trade date:'} </DataHeading>
                                            {/* removing time as per the bug 6622 */}
                                            <Heading className="ml-10">{moment(moment.tz(exchangeDetails.tradeDate, 'America/New_York')).format("MM/DD/YYYY")}</Heading>
                                        </ViewEditField>

                                    </div>
                                </>
                            }

                        </FlexContainer>
                        <PrintComponents
                            data-test="printDiv"
                            className="i_print"                            
                            trigger={
                                <PrintDiv >
                                    <DisplayFlex className="hide-for-print">
                                        <img src={printIcon} alt="print icon"/>
                                        <PrintButton data-test="printInner" id="btnPrint" onClick={() => printClicked()}>PRINT</PrintButton>
                                    </DisplayFlex>
                                </PrintDiv>
                            }>
                                <div className="mb-30">
                                    <RecommendAnExchangesHeading>
                                        {from && from.scheduleType === ScheduleTypeConstants.recurring ?
                                            `Schedule ID: ${id}` :
                                            `Transaction ID: ${id}`
                                        }
                                    </RecommendAnExchangesHeading>
                                    <SectionSpacing className="mb-30">
                                        <Row>
                                            <Col xs={12} md={24}>
                                                <SummaryLabel>{exchangeDetails.fundName}</SummaryLabel>
                                            </Col>
                                            <Col xs={12} md={24}>
                                                <SummaryData>{getPrimaryAccount()?.accountNumber}</SummaryData>
                                            </Col>
                                        </Row>
                                    </SectionSpacing>
                                    <SectionSpacing className="mt-30 mb-30">
                                        <SubSection>
                                            <FlexContainer wrapInMobile>
                                                <div>
                                                    <ViewEditField>
                                                        <DataHeading>Entered Date: </DataHeading>
                                                        <Heading className="ml-10">{from?.scheduleType === ScheduleTypeConstants.recurring ? moment(moment.tz(exchangeDetails.exchangeCreateDate, 'America/New_York')).format('MM/DD/YYYY') : moment(moment.tz(exchangeDetails.enteredDate, 'America/New_York')).format('MM/DD/YYYY')}</Heading>
                                                    </ViewEditField>
                                                    <ViewEditField>
                                                        <DataHeading>Status:</DataHeading>
                                                        <Heading className="ml-10">{exchangeDetails.status}</Heading>
                                                    </ViewEditField>

                                                </div>
                                                {from && from.scheduleType === ScheduleTypeConstants.onetime &&
                                                    <>
                                                        <HrDivider hideInMobile />
                                                        <div>
                                                            <ViewEditField>
                                                                <DataHeading>Recieved date & time: </DataHeading>
                                                                <Heading className="ml-10">{moment(moment.tz(exchangeDetails.receivedDate, 'America/New_York')).format('MM/DD/YYYY [at] hh:mm A')}</Heading>
                                                            </ViewEditField>
                                                            <ViewEditField>
                                                                <DataHeading>{exchangeDetails.status === 'Completed' ? 'Trade Date:' : 'Estimated trade date:'} </DataHeading>
                                                                {/* removing time as per the bug 6622 */}
                                                                <Heading className="ml-10">{moment(moment.tz(exchangeDetails.tradeDate, 'America/New_York')).format("MM/DD/YYYY")}</Heading>
                                                            </ViewEditField>

                                                        </div>
                                                    </>
                                                }

                                            </FlexContainer>
                                        </SubSection>

                                    </SectionSpacing>
                                    <Divider className="m0" />
                                    <CustomSectionSpacing>
                                        <Row>
                                            <ExchangeOptions
                                                scheduleType={from?.scheduleType}
                                                exchangeType={from?.exchangeType}
                                                total={calTotalAmount(from)}
                                                edit={updatedEdit}
                                                history={history}
                                                id={id}
                                                location={location}
                                                status={exchangeDetails.status}
                                                tradeDate={moment(moment.tz(exchangeDetails.tradeDate, 'America/New_York')).format("MM/DD/YYYY")}
                                                isNew={isNew}
                                                isViewEdit={true}
                                            />
                                            {from && from.scheduleType === ScheduleTypeConstants.recurring ?
                                                <ExchangeSchedule
                                                    frequency={from?.frequency}
                                                    numberOfExchanges={from?.numberOfExchanges}
                                                    startDate={moment(spawnsArr[0].exchangeDate).format('MM/DD/YYYY')}
                                                    endDate={from?.endDate}
                                                    edit={updatedEdit}
                                                    history={history}
                                                    id={id}
                                                    location={location}
                                                    isViewEdit={true}
                                                /> : ''
                                            }
                                        </Row>
                                    </CustomSectionSpacing>
                                    <Divider className="m0" />
                                    <SectionSpacing>
                                        <FlexContainer>
                                            <SectionHeading>Recommend exchange from</SectionHeading>
                                            {updatedEdit && <CapsuleButton data-test="editExchange" iconType="edit" text="edit" id="btnEditRecmndExchngFrm" onClick={(e) => {
                                                try {
                                                    const scheduleTypeLabel = from?.scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange';
                                                    initiateTracking('edit', 'View and Edit Exchange', 'Recommend exchange from', `Edit - ${scheduleTypeLabel}`);    
                                                    let params = queryString.parse(location.search);
                                                    params = params ? { ...params, edit: true } : { edit: true }
                                                    history.push({
                                                        pathname: `/investments/recommend-an-exchange/${id}/from`,
                                                        search: queryString.stringify(params)
                                                    });
                                                } catch (error) {
                                                  recordError(error);
                                                }
                                            }} />}
                                        </FlexContainer>
                                        <Row>
                                            <Col xs={24} lg={12}>
                                                <FromTable 
                                                   isPrintCheck={true}
                                                   printRender = {(columns) => <CustomPrintTable dataSource={from?.pools} columns={columns} /> } 
                                                   dataSource={from?.pools} 
                                                   exchangeType={from?.exchangeType} 
                                                   allocationType={from?.allocationType} 
                                                   isConfirmation="true" 
                                                />
                                            </Col>
                                        </Row>
                                        {from && from.scheduleType === ScheduleTypeConstants.recurring && <Row>
                                            <ViewLabel>Note: Displaying exchange data for the upcoming 'Exchange {getCurrentSpawn()}'. Exchange data might be different for completed/upcoming exchanges in the schedule.</ViewLabel>
                                        </Row>}
                                    </SectionSpacing>
                                    <Divider className="m0" />
                                    <SectionSpacing>
                                        <FlexContainer>
                                            <SectionHeading>Recommend exchange to</SectionHeading>
                                            {updatedEdit && <EditButton id="btnEditExchnageTo" onClick={(e) => {
                                                try {
                                                    const scheduleTypeLabel = from?.scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange';
                                                    initiateTracking('edit', 'View and Edit Exchange', 'Recommend exchange to', `Edit - ${scheduleTypeLabel}`);   
                                                    let params = queryString.parse(location.search);
                                                    params = params ? { ...params, edit: true } : { edit: true }
                                                    history.push({
                                                        pathname: `/investments/recommend-an-exchange/${id}/to`,
                                                        search: queryString.stringify(params)
                                                    });
                                                } catch (error) {
                                                  recordError(error);
                                                }
                                            }} />
                                            }
                                        </FlexContainer>
                                        <Row>
                                            <Col xs={24} lg={12}>
                                                <ToTable 
                                                    dataSource={to?.pools} 
                                                    printRender = {(columns) => <CustomPrintTable columns={columns} dataSource={to?.pools} /> }
                                                    isPrintCheck={true}
                                                    isReview={false} 
                                                    isLegacy={exchangeDetails.legacy} 
                                                    reversedExchange={exchangeDetails.reversedExchange} 
                                                    status={exchangeDetails.status}
                                                    instructionType={exchangeDetails.instructionType}
                                                />
                                            </Col>
                                        </Row>
                                        {from && from.scheduleType === ScheduleTypeConstants.recurring &&  <Row>
                                            <ViewLabel>Note: Displaying exchange data for the upcoming 'Exchange {getCurrentSpawn()}'. Exchange data might be different for completed/upcoming exchanges in the schedule.</ViewLabel>
                                        </Row> }
                                    </SectionSpacing>
                                    <Divider className="m0" />
                                    {from && from.scheduleType === ScheduleTypeConstants.recurring &&
                                        <>
                                            <SectionSpacing>
                                                <FlexContainer>
                                                    <SectionHeading>Recommend exchange schedule</SectionHeading>
                                                </FlexContainer>
                                                <Row>
                                                    <Col span={24}>
                                                        <SpawnTable
                                                            dataSource={spawnsArr}
                                                            isViewEdit={true}
                                                            userId={userId}
                                                            exchScheduleId={exchangeDetails.exchScheduleId}
                                                            history={history}
                                                            refreshExchangeDetails={refreshExchangeDetails}
                                                            persistContext={persistContext}
                                                            status={exchangeDetails.status}
                                                            edit={edit}
                                                            isBalanceZero={isBalanceZero}
                                                            csrBusinessFunction={csrBusinessFunction}
                                                            cancellingReversingSpawn={cancellingReversingSpawn}  
                                                            isPrintCheck={true}
                                                            isAllShareAllPoolExist={isAllShareAllPoolExist}
                                                            printRender = {(columns, dataSource) => <CustomPrintSpawnTable dataSource={dataSource} columns={columns} /> }                                        
                                                        />
                                                    </Col>
                                                    {updatedEdit && <AddExchangeSection span={24}>
                                                        {/* Add another exchange failure message */}
                                                        {addExchangeFailed && <AddExchangeMessage>Failed to add exchange, please try again.</AddExchangeMessage>}
                                                        {/* A user will be able to add a maximum of 99 recurring payments under any frequency */}
                                                        {(exchangeDetails.noOfExchangesRemaining >= ExchangesMaxLimitConstant) ? <>
                                                            <AddExchangeMessage>You have reached the maximum limit of recurring payments</AddExchangeMessage>
                                                            <AddTransaction id="btnAddAnotherExchng" className='ant-btn' disabled={true}>Add Another Exchange +</AddTransaction>
                                                        </>
                                                            : <AddTransaction 
                                                                id="btnAddAnotherExchange"
                                                                className='ant-btn' 
                                                                loading={spawnsLoading}
                                                                disabled={checkCsrBusiness('DONOR_PORTAL_EDIT_RECURRING_EXCHANGE_FULL_ACCESS')}
                                                                onClick={() => {
                                                                    try {
                                                                        setAddExchangeFailed(false);
                                                                        setAddAnotherExchange(true)
                                                                    } catch (error) {
                                                                      recordError(error);
                                                                    }
                                                            }}>Add Another Exchange +
                                                            <ButtonLoader src={loaderIcon} alt='loader'/>
                                                            </AddTransaction>}
                                                    </AddExchangeSection>}
                                                </Row>
                                            </SectionSpacing>
                                        </>
                                    }
                                </div>
                        </PrintComponents>
                    </SubSection>

                </SectionSpacing>
                <Divider className="m0" />
                <CustomSectionSpacing>
                    <Row>
                        <ExchangeOptions
                            scheduleType={from?.scheduleType}
                            exchangeType={from?.exchangeType}
                            total={calTotalAmount(from)}
                            edit={updatedEdit}
                            history={history}
                            id={id}
                            location={location}
                            status={exchangeDetails.status}
                            tradeDate={moment(moment.tz(exchangeDetails.tradeDate, 'America/New_York')).format("MM/DD/YYYY")}
                            isNew={isNew}
                            isViewEdit={true}
                        />
                        {from && from.scheduleType === ScheduleTypeConstants.recurring ?
                            <ExchangeSchedule
                                frequency={from?.frequency}
                                numberOfExchanges={from?.numberOfExchanges}
                                startDate={moment(spawnsArr[0].exchangeDate).format('MM/DD/YYYY')}
                                endDate={from?.endDate}
                                edit={updatedEdit}
                                history={history}
                                id={id}
                                location={location}
                                isViewEdit={true}
                            /> : ''
                        }
                    </Row>
                </CustomSectionSpacing>
                <Divider className="m0" />
                <SectionSpacing>
                    <FlexContainer>
                        <SectionHeading>Recommend exchange from</SectionHeading>
                        {updatedEdit && <CapsuleButton iconType="edit" text="Edit" id="btnEditRecmndExchngFrm" onClick={(e) => {
                            try {
                                const scheduleTypeLabel = from?.scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange';
                                initiateTracking('edit', 'View and Edit Exchange', 'Recommend exchange from', `Edit - ${scheduleTypeLabel}`);    
                                let params = queryString.parse(location.search);
                                params = params ? { ...params, edit: true } : { edit: true }
                                history.push({
                                    pathname: `/investments/recommend-an-exchange/${id}/from`,
                                    search: queryString.stringify(params)
                                });
                            } catch (error) {
                              recordError(error);
                            }
                        }} />}
                    </FlexContainer>
                    <Row>
                        <Col xs={24} lg={12}>
                            <FromTable dataSource={from?.pools} exchangeType={from?.exchangeType} allocationType={from?.allocationType} isConfirmation="true" />
                        </Col>
                    </Row>
                    {from && from.scheduleType === ScheduleTypeConstants.recurring && <Row>
                        <ViewLabel>Note: Displaying exchange data for the upcoming 'Exchange {getCurrentSpawn()}'. Exchange data might be different for completed/upcoming exchanges in the schedule.</ViewLabel>
                    </Row>}
                </SectionSpacing>
                <Divider className="m0" />
                <SectionSpacing>
                    <FlexContainer>
                        <SectionHeading>Recommend exchange to</SectionHeading>
                        {updatedEdit && <CapsuleButton iconType="edit" text="Edit" id="btnEditRecomndExchngTo" onClick={(e) => {
                            try {
                                const scheduleTypeLabel = from?.scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange';
                                initiateTracking('edit', 'View and Edit Exchange', 'Recommend exchange to', `Edit - ${scheduleTypeLabel}`);   
                                let params = queryString.parse(location.search);
                                params = params ? { ...params, edit: true } : { edit: true }
                                history.push({
                                    pathname: `/investments/recommend-an-exchange/${id}/to`,
                                    search: queryString.stringify(params)
                                });
                            } catch (error) {
                              recordError(error);
                            }
                        }} />
                        }
                    </FlexContainer>
                    <Row>
                        <Col xs={24} lg={12}>
                            <ToTable 
                                dataSource={to?.pools} 
                                isReview={false} 
                                isLegacy={exchangeDetails.legacy} 
                                reversedExchange={exchangeDetails.reversedExchange} 
                                status={exchangeDetails.status}
                                instructionType={exchangeDetails.instructionType}
                            />
                        </Col>
                    </Row>
                    {from && from.scheduleType === ScheduleTypeConstants.recurring &&  <Row>
                        <ViewLabel>Note: Displaying exchange data for the upcoming 'Exchange {getCurrentSpawn()}'. Exchange data might be different for completed/upcoming exchanges in the schedule.</ViewLabel>
                    </Row> }
                </SectionSpacing>
                <Divider className="m0" />
                {from && from.scheduleType === ScheduleTypeConstants.recurring &&
                    <>
                        <SectionSpacing>
                            <FlexContainer>
                                <SectionHeading>Recommend exchange schedule</SectionHeading>
                            </FlexContainer>
                            <Row>
                                <Col span={24}>
                                    <SpawnTable
                                        dataSource={spawnsArr}
                                        isViewEdit={true}
                                        userId={userId}
                                        exchScheduleId={exchangeDetails.exchScheduleId}
                                        history={history}
                                        refreshExchangeDetails={refreshExchangeDetails}
                                        persistContext={persistContext}
                                        status={exchangeDetails.status}
                                        edit={edit}
                                        isBalanceZero={isBalanceZero}
                                        isAllShareAllPoolExist={isAllShareAllPoolExist}
                                        csrBusinessFunction={csrBusinessFunction}
                                        cancellingReversingSpawn={cancellingReversingSpawn}                                        
                                    />
                                </Col>
                                {updatedEdit && <AddExchangeSection span={24}>
                                    {/* Add another exchange failure message */}
                                    {addExchangeFailed && <AddExchangeMessage>Failed to add exchange, please try again.</AddExchangeMessage>}
                                    {/* A user will be able to add a maximum of 99 recurring payments under any frequency */}
                                    {(exchangeDetails.noOfExchangesRemaining >= ExchangesMaxLimitConstant) ? <>
                                        <AddExchangeMessage>You have reached the maximum limit of recurring payments</AddExchangeMessage>
                                        <AddTransaction id="btnAddAnotherTransaction" className='ant-btn' disabled={true}>Add Another Exchange +</AddTransaction>
                                    </>
                                        : <AddTransaction className='ant-btn' 
                                            loading={spawnsLoading}
                                            disabled={checkCsrBusiness('DONOR_PORTAL_EDIT_RECURRING_EXCHANGE_FULL_ACCESS')}
                                            onClick={() => {
                                            setAddExchangeFailed(false);
                                            setAddAnotherExchange(true)
                                        }}>Add Another Exchange +
                                        <ButtonLoader src={loaderIcon} alt='loader'/>
                                        </AddTransaction>}
                                </AddExchangeSection>}
                            </Row>
                        </SectionSpacing>
                    </>
                }
            </div>
            {from && from.scheduleType === ScheduleTypeConstants.recurring && edit &&
                <>
                    <SectionSpacing>
                        <NavigationGroupButton>
                            <GeneralButton  
                                mobWidth="100%"
                                text="Cancel all remaining exchanges" 
                                id="btnCancelRemainingExchg" 
                                onClick={() => handleCancelAllExchangePopUp(true)} 
                                disabled={checkCsrBusiness('DONOR_PORTAL_EDIT_RECURRING_EXCHANGE_FULL_ACCESS')}
                            />
                            {!isExchangeHidden ?
                                <GeneralButton  
                                    mobWidth="100%"
                                    text="Hide completed exchanges" 
                                    id="btnHideCompltdExchg" 
                                    onClick={hideCompeletedExchange} 
                                /> :
                                <GeneralButton  
                                    mobWidth="100%"
                                    text="Show All Exchanges" 
                                    id="btnShowAllExchg" 
                                    onClick={showAllExchange} 
                                />
                            }
                        </NavigationGroupButton>
                    </SectionSpacing>
                    <Divider className="my-lg3 my-sm3" />
                </>
            }
            <NavigationBtnContainer className='flex'>
                <GeneralButton data-test="backBtn" mobWidth="100%" type="functional" inverted={true}  width="150px" text="Back" id="btnBack" onClick={() => backClicked()}/>
            </NavigationBtnContainer>
            <AlertMessagePrimary
                data-test="cancelExchanges"
                className="altCancelAllExchanges"
                visible={cancelAllExchangePopUp}
                title={
                    <AlertContent
                        page={"Edit Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Cancel All Exchanges"}
                        property={"field_header"}
                        defaultMessage={"Cancel"}
                    />
                }
                onOk={cancelAllExchange}
                onCancel={() => handleCancelAllExchangePopUp(false)}
                cancelText={
                    <AlertContent
                        page={"Edit Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Cancel All Exchanges"}
                        property={"field_alert_button2_text"}
                        defaultMessage={"No, take me back"}
                        isButton={true}
                    />
                }
                okText={
                    <AlertContent
                        page={"Edit Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Cancel All Exchanges"}
                        property={"field_alert_button1_text"}
                        defaultMessage={"CONTINUE"}
                        isButton={true}
                    />
                }
            >
                 <AlertContent
                    page={"Edit Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Cancel All Exchanges"}
                    property={"field_description"}
                    html={true}
                    defaultMessage={"Are you sure you want to cancel all remaining exchanges?"}
                />
            </AlertMessagePrimary>
            <AlertMessagePrimary
                data-test="addAnotherExchange"
                className="altAddAnotherExchange"
                title={
                    <AlertContent
                        page={"Edit Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Add Another Exchange"}
                        property={"field_header"}
                        defaultMessage={"Add Another Exchange"}
                    />
                }
                visible={isAddAnotherExchange}
                onOk={addPayment}
                onCancel={() => { setAddAnotherExchange(false) }}
                cancelText={
                    <AlertContent
                        page={"Edit Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Add Another Exchange"}
                        property={"field_alert_button2_text"}
                        defaultMessage={"No, take me back"}
                        isButton={true}
                    />
                }
                okText={
                    <AlertContent
                        page={"Edit Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Add Another Exchange"}
                        property={"field_alert_button1_text"}
                        defaultMessage={"CONTINUE"}
                        isButton={true}
                    />
                }
            >
                 <AlertContent
                    page={"Edit Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Add Another Exchange"}
                    property={"field_description"}
                    html={true}
                    defaultMessage={"The exchange spawn added to the schedule will follow and details of the previous spawn in the schedule.The system auto-calculates and adds another spawn to the end of the schedule. The date of exchange (based on frequency) and other required values are based on the exchange details as above. This will also further update details such as ‘Frequency’, ‘Number of Exchanges’ and ‘End Date’ of the Recurring Schedule."}
                />
             </AlertMessagePrimary>
        </>
    );
};

ViewAndEdit.propTypes = {
    userId: PropTypes.string,
    handleExit: PropTypes.func,
    exchangeDetails: PropTypes.string,
    handleBack: PropTypes.func,
    getInitialData: PropTypes.func,
    edit: PropTypes.bool,
    isDirty: PropTypes.bool,
    id: PropTypes.string,
    isLoading: PropTypes.bool,
    exchPendingSpawnId: PropTypes.string,
    isBalanceZero: PropTypes.bool,
  }

export default withRouter(ViewAndEdit);